import React, { Component } from 'react'

export default ({ width=19 }) => {

  return (
    <svg width={width} height={.842105263 * width} viewBox="0 0 19 16">
      <path id="max" fill="#f1f1f1" d="M16.17,15l-.75-.69a9.23,9.23,0,0,0,0-12.73l.75-.69A10.23,10.23,0,0,1,16.17,15Z"/>
      <path id="low" fill="#f1f1f1" d="M13.49,12.17l-.77-.66a5.23,5.23,0,0,0,0-7.06l.77-.68A6.23,6.23,0,0,1,15.1,8,6.34,6.34,0,0,1,13.49,12.17Z"/>
      <path id="none" fill="#f1f1f1" d="M11,16,4.24,11.9H0V4.12H4.24L11,0ZM1,10.89H4.54L10,14.21V1.81L4.54,5.13H1Z"/>
    </svg>
  );
};



// WEBPACK FOOTER //
// ./src/components/visuals/Speaker.js